import Vue from 'vue'
import store from './store/store'

window.pushHelper = new Vue({
  store,
  data: {
    applicationServerPublicKey: 'BH+5ZxuSGINbV1BPF1F8vrqVvFRNDgXmNlyFdrFl78KZQWXwOHYTCTlPgz8PaUfS8jMNwMjh31hCNBRUyPGhpx4=',
    registration: null,
    isSubscribed: false,
    // userId: localStorage.getItem('userId') || 0,
    // schoolId: localStorage.getItem('schoolId') || 0
    Dbasename: store.state.Dbasename,
    userId: store.state.userId || 0,
    schoolId: store.state.schoolId || 0

  },

  methods: {
    // call when service worker is registered
    checkSubscription (registration) {
      this.registration = registration

      registration.pushManager.getSubscription()
        .then((subscription) => {
          if (typeof this.userId !== 'undefined' && this.userId !== 0 && subscription !== null) {
            const key = subscription.getKey('p256dh')
            const token = subscription.getKey('auth')
            const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0]
            window.axios({
              method: 'post',
              url: 'https://www.atschool.co.nz/api/v2/caregiversV2/' + this.Dbasename + '/' + this.userId + '/getSubscriptionStatusV2',
              data: {
                subscription: JSON.stringify({
                  endpoint: subscription.endpoint,
                  publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                  authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
                  contentEncoding
                })
              }
            })
              .then((resp) => {
                // console.log(resp.data)
                this.isSubscribed = resp.data.subscribed
              })
          }

          // this.isSubscribed = !(subscription === null)
          // console.log(JSON.stringify(subscription))

          if (subscription) { return subscription }

          // send subscription info to server (the server will send push notification to this subscription)
          // this.updateSubscriptionOnServer({ subscription: subscription, isActive: this.isSubscribed })

          // update UI to indicate Push Notification is subscribed or not
          // this.initUi({ isSubscribed: this.isSubscribed })
        })
    },
    // subscribe push notification
    subscribe (userId, schoolId) {
      this.userId = userId
      this.schoolId = schoolId

      const applicationServerKey = this.urlB64ToUint8Array(this.applicationServerPublicKey)

      return this.registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey
      })
        .then((subscription) => {
          // subscription successful, send subscription info to server
          this.updateSubscriptionOnServer({ subscription, isActive: true })
          this.isSubscribed = true
          return true
        })
    },
    // unsubscribe push notification
    unsubscribe () {
      return this.registration.pushManager.getSubscription()
        .then((subscription) => {
          if (subscription) {
            // unsubscribe successful, update server
            this.updateSubscriptionOnServer({ subscription, isActive: false })
            this.isSubscribed = false
            return subscription.unsubscribe()
          }
          return false
        })
    },
    // send subscription info to server
    updateSubscriptionOnServer ({ subscription, isActive }) {
      // console.log(this.userId)
      // console.log(JSON.stringify(subscription))
      if (subscription) {
        const key = subscription.getKey('p256dh')
        const token = subscription.getKey('auth')
        const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0]

        window.axios({
          method: 'post',
          url: 'https://www.atschool.co.nz/api/v2/registerPushSubscriptionV2/' + this.Dbasename,
          data: {
            // subscription: JSON.stringify(subscription),
            subscription: JSON.stringify({
              endpoint: subscription.endpoint,
              publicKey: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
              authToken: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
              contentEncoding
            }),
            is_active: isActive,
            caregiverId: this.userId,
            schoolId: this.schoolId
          }
        })
          // .then((response) => {
          //   console.log(response.data)
          // })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    // convert applicationServerPublicKey
    urlB64ToUint8Array (base64String) {
      const padding = '='.repeat((4 - base64String.length % 4) % 4)
      const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/')

      const rawData = window.atob(base64)
      const outputArray = new Uint8Array(rawData.length)

      for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
      }
      return outputArray
    }

  }
})
